 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import {MenuPosition} from '~/hooks/useCoords'
import useMenu from '~/hooks/useMenu'
import lazyPreload from '~/utils/lazyPreload'

import {PALETTE} from '../styles/paletteV3'
import defaultUserAvatar from '../styles/theme/images/avatar-user.svg'
import Avatar from './Avatar/Avatar'

const AvatarWrapper = styled('button')({
  background: 'transparent',
  border: 'none',
  borderRadius: 100,
  marginLeft: 8,
  padding: 4,
  ':focus': {
    boxShadow: `0 0 0 2px ${PALETTE.SKY_400}`,
    cursor: 'pointer',
    outline: 'none'
  },
  ':active': {
    boxShadow: '0 0 0 2px transparent'
  }
})

const StandardHubUserMenu = lazyPreload(
  () => import(/* webpackChunkName: 'StandardHubUserMenu' */ './StandardHubUserMenu')
)





const TopBarAvatar = (props) => {
  const {viewer: viewerRef} = props
  const viewer = useFragment(
    graphql`
      fragment TopBarAvatar_viewer on User {
        picture
        ...StandardHubUserMenu_viewer
      }
    `,
    viewerRef
  )
  const userAvatar = _nullishCoalesce(_optionalChain([viewer, 'optionalAccess', _ => _.picture]), () => ( defaultUserAvatar))
  const {togglePortal, originRef, menuPortal, menuProps} = useMenu(
    MenuPosition.UPPER_RIGHT
  )
  return (
    React.createElement(React.Fragment, null
      , React.createElement(AvatarWrapper, { onClick: togglePortal,}
        , React.createElement(Avatar, {
          onMouseEnter: StandardHubUserMenu.preload,
          ref: originRef,
          hasBadge: false,
          picture: userAvatar,
          size: 40,}
        )
        , viewer && menuPortal(React.createElement(StandardHubUserMenu, { menuProps: menuProps, viewerRef: viewer,} ))
      )
    )
  )
}

export default TopBarAvatar
